<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                class="mt-3"
                :pages="[
                    {
                        name: $tc('messages.ad_sponsors', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div v-if="sponsors.length > 0">
            <div class="flex md:gap-6 gap-2 justify-center items-center">
                <div v-for="sponsor in sponsors" :key="sponsor.id" class="md:w-1/3">
                    <a :href="sponsor.url" target="_blank" rel="noopener noreferrer">
                        <img :src="sponsor.image_path" :alt="sponsor.name" class="w-full" />
                    </a>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import PanelPage from '@/Shared/PanelPage.vue';
import LandingLayout from '@/Shared/LandingLayout.vue';

export default {
    components: {
        PanelPage,
    },
    layout: LandingLayout,
    name: 'Index',
    props: ['sponsors', 'meta'],
};
</script>
